import React from 'react'
import { Icon } from '@chakra-ui/react'
import { Button, ButtonProps } from '@chakra-ui/react'
import { GrFlag, GrFlagFill } from 'react-icons/gr'

import {
    ActionItemStatus,
    ActionItemFieldsFragment,
    useUpdateActionItemMutation,
} from '~graphql/generated/graphql'
import { Tooltip, TooltipProps } from '@chakra-ui/react'

interface Props extends ButtonProps {
    actionItem: ActionItemFieldsFragment
    tooltipProps?: Partial<TooltipProps>
}

export default function UnderReviewFlag({
    actionItem,
    tooltipProps,
    ...rest
}: Props) {
    const { status } = actionItem

    const isUnderReview = status === ActionItemStatus.UnderReview

    const [updateActionItem] = useUpdateActionItemMutation()

    function handleToggleUnderReview() {
        updateActionItem({
            variables: {
                id: actionItem.id,
                data: {
                    status: isUnderReview
                        ? ActionItemStatus.Pending
                        : ActionItemStatus.UnderReview,
                },
            },
        })
    }

    return (
        <Tooltip
            label={
                isUnderReview ? 'Remove review flag' : 'Flag as "under review"'
            }
            {...tooltipProps}
        >
            <Button
                px={1}
                py={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
                role="group"
                rounded="full"
                variant="ghost"
                onClick={handleToggleUnderReview}
                {...rest}
            >
                <Icon
                    as={isUnderReview ? GrFlagFill : GrFlag}
                    color={isUnderReview ? 'red.500' : 'gray.500'}
                    _groupHover={
                        isUnderReview
                            ? { color: 'red.600' }
                            : {
                                  color: 'red.500',
                                  opacity: 0.7,
                              }
                    }
                />
            </Button>
        </Tooltip>
    )
}
